import { BlocksIconPhone } from 'blocks-nextjs/blocks-web-components/components/icon/icons/phone';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconPhone = createComponent({ react: React, tagName: 'cat-icon-phone', elementClass: BlocksIconPhone });
